"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRANSACTION_VERSION_TX_HASH_SIGN = exports.TRANSACTION_OPTIONS_TX_HASH_SIGN = exports.LEDGER_TX_HASH_SIGN_MIN_VERSION = void 0;
// This constant represents the minimum version in which the MultiversX Ledger App doesn't support anymore regular
// transactions' signing, and uses transaction's hash signing instead
exports.LEDGER_TX_HASH_SIGN_MIN_VERSION = "1.0.11";
exports.TRANSACTION_OPTIONS_TX_HASH_SIGN = 1;
exports.TRANSACTION_VERSION_TX_HASH_SIGN = 2;
//# sourceMappingURL=constants.js.map